/**
 * Shared shell layout constants (PRO-0340). The module rail uses `md:w-72`; the
 * banner grid must stay in lockstep so the wordmark column aligns with the rail
 * and account controls sit above the workspace column (not `justify-between` across
 * the full shell width).
 */
export const SHELL_RAIL_WIDTH_CLASS = 'md:w-72';
export const SHELL_HEADER_GRID_CLASS = 'md:grid md:grid-cols-[18rem_minmax(0,1fr)]';
